import Vue from "vue"; // Use inhanced localStorage-like library vlf to client-side caching

import Vlf from 'vlf';
import localforage from 'localforage';
Vue.use(Vlf, localforage); // Examples of use. More examples can be found at https://github.com/dmlzj/vlf
// this.$vlf.setItem('test', 'hello, GTS!').then(v => console.log(v));
// this.$vlf.getItem('test').then(v => console.log(v));